import type {AppThunk} from '../../../../actions/types'
import {getInvestigationArg} from '../../../../rest/investigations'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../../routes/loadEndpoint'
import {restApi} from '../../../../services/rest'
import type {BuildTypeId} from '../../../../types'

export const preloadBuildTypeInvestigationsBadge =
  (buildTypeId: BuildTypeId | null | undefined): AppThunk<LoadedEndpoints> =>
  dispatch => [
    buildTypeId != null &&
      dispatch(
        loadEndpoint(restApi.endpoints.getAllInvestigations, getInvestigationArg(buildTypeId)),
      ),
  ]
